<script lang="ts">
  let { compact = false, celebrating = false }: { compact?: boolean; celebrating?: boolean } = $props();
</script>

<svg class:compact class:celebrating viewBox="0 0 420 420" role="img" aria-label="A radiant peacock-inspired badge">
  <defs>
    <radialGradient id="eye" cx="50%" cy="38%" r="65%">
      <stop offset="0" stop-color="#f8c84a" />
      <stop offset=".32" stop-color="#f8c84a" />
      <stop offset=".34" stop-color="#173e64" />
      <stop offset=".61" stop-color="#173e64" />
      <stop offset=".63" stop-color="#2fc5b4" />
      <stop offset="1" stop-color="#087d75" />
    </radialGradient>
    <linearGradient id="body" x1="0" y1="0" x2="1" y2="1">
      <stop stop-color="#35d0bd" />
      <stop offset="1" stop-color="#12698c" />
    </linearGradient>
    <filter id="soft"><feGaussianBlur stdDeviation="6" /></filter>
  </defs>

  <circle class="aura" cx="210" cy="210" r="176" />
  <g class="feathers">
    {#each [-68, -45, -22, 0, 22, 45, 68] as angle, index}
      <g class="feather" style={`--angle:${angle}deg;--delay:${index * 70}ms`}>
        <path d="M210 216 C152 138 158 55 210 19 C262 55 268 138 210 216Z" fill="url(#eye)" />
        <path d="M210 205 C204 135 205 71 210 30" fill="none" stroke="#f9f1de" stroke-opacity=".58" stroke-width="2" />
      </g>
    {/each}
  </g>
  <circle class="halo" cx="210" cy="231" r="93" />
  <path class="body" d="M153 316c10-62 31-112 57-139 26 27 47 77 57 139-34 23-80 23-114 0Z" fill="url(#body)" />
  <path class="neck" d="M204 177c-14 18-19 46-14 74 4 24 14 42 20 51 6-9 16-27 20-51 5-28 0-56-14-74Z" fill="#164f78" />
  <circle cx="217" cy="202" r="4" fill="#f8c84a" />
  <path d="M223 210l22 8-22 7Z" fill="#ef7d67" />
  <g class="crest" stroke="#f8c84a" stroke-width="3" stroke-linecap="round">
    <path d="M205 183l-8-20" /><path d="M211 180v-23" /><path d="M217 183l9-20" />
  </g>
  <circle class="ring" cx="210" cy="258" r="73" />
  <text x="210" y="270" text-anchor="middle" aria-label="plus plus"><tspan>+</tspan><tspan dx="-8">+</tspan></text>
  <g class="sparks" aria-hidden="true">
    <circle cx="51" cy="96" r="5" /><circle cx="362" cy="77" r="4" /><circle cx="381" cy="263" r="5" />
    <path d="M58 302h24M70 290v24M333 331h20M343 321v20" />
  </g>
</svg>

<style>
  svg { display: block; width: 100%; overflow: visible; }
  .aura { fill: #40266f; opacity: .14; filter: url(#soft); }
  .feather { transform-origin: 210px 216px; transform: rotate(var(--angle)); animation: unfurl 700ms cubic-bezier(.2,.8,.2,1) both; animation-delay: var(--delay); }
  .halo { fill: #f5e9d5; stroke: #272034; stroke-width: 3; }
  .body, .neck { stroke: #272034; stroke-width: 3; }
  .ring { fill: #ee735f; stroke: #272034; stroke-width: 3; }
  text { fill: #f9efdd; font-family: var(--display); font-size: 48px; font-style: normal; font-weight: 500; }
  .sparks { fill: #f8c84a; stroke: #f8c84a; stroke-width: 3; stroke-linecap: round; opacity: 0; transform-origin: center; }
  .celebrating .sparks { animation: sparkle 900ms cubic-bezier(.2,.8,.2,1) both; }
  .compact .feathers { animation: none; }
  @keyframes unfurl { from { opacity: 0; transform: rotate(var(--angle)) scale(.35); } to { opacity: 1; transform: rotate(var(--angle)) scale(1); } }
  @keyframes sparkle { 0% { opacity: 0; transform: scale(.5) rotate(-15deg); } 45% { opacity: 1; } 100% { opacity: .8; transform: scale(1) rotate(0); } }
  @media (prefers-reduced-motion: reduce) { .feather, .celebrating .sparks { animation: none; opacity: 1; } }
</style>
